import {
    MessageSquare, Bot, Zap, CreditCard, Mail, Flag, CheckCircle2, FileText,
    CalendarClock, Split, Clock, MousePointerClick, GitBranch, ArrowUpRight,
    Braces, Globe, PhoneForwarded, Phone, Webhook, UserPen, Code2, Star,
    Briefcase, Repeat,
} from 'lucide-react';

/**
 * Ícone de cada nó — o mesmo que a Biblioteca do editor desenha.
 *
 * O catálogo compartilhado guarda o NOME do ícone, porque a API também o lê e
 * lá não existe React. A resolução para componente mora aqui, e é usada tanto
 * pela paleta quanto pelo diagrama que o Lucas responde.
 *
 * Ter um mapa só importa mais do que parece: é pelo ícone que a pessoa varre o
 * painel. Um diagrama com ícone diferente do da biblioteca faria ela procurar
 * a coisa errada — que é justamente o problema que o nome de tela resolveu, na
 * outra metade.
 */

const projurisLogo = '/assets/projuris_icon.svg';
const advboxLogo = '/assets/advbox.svg';
const astreaLogo = '/assets/astrea_icon.svg';
const fazLogo = '/assets/faz-azul.png';
const trelloLogo = '/assets/trello-logo-icon.svg';
const controljusLogo = '/assets/controljus_icon.svg';

/** As integrações têm marca própria: ícone genérico descaracterizaria. */
const brand = (src) =>
    function BrandIcon({ className }) {
        return <img src={src} className={`${className} object-contain`} alt="" />;
    };

export const ProjurisIcon = brand(projurisLogo);
export const ControlJusIcon = brand(controljusLogo);
export const AdvBoxIcon = brand(advboxLogo);
export const AstreaIcon = brand(astreaLogo);
export const FazIcon = brand(fazLogo);
export const TrelloIcon = brand(trelloLogo);

export const NODE_ICONS = {
    Flag, Phone, Webhook, CalendarClock, CheckCircle2, FileText, Split, GitBranch,
    Repeat, Clock, MousePointerClick, ArrowUpRight, Braces, Code2, Bot,
    MessageSquare, UserPen, Briefcase, PhoneForwarded, Zap, Mail, CreditCard,
    Globe, Star, ProjurisIcon, ControlJusIcon, AdvBoxIcon, AstreaIcon, FazIcon, TrelloIcon,
};

/**
 * @param {string} name nome vindo do catálogo
 * @returns {Function|null} componente de ícone, ou null se o nome não existir
 */
export function nodeIcon(name) {
    return NODE_ICONS[name] || null;
}

export default NODE_ICONS;
